export default {
    data() {
        return {
            honeypot: 'faxonly',
        }
    },
    methods: {
        getBotFormData(data = {}) {
            let checkbox = document.getElementById(this.honeypot);
            return {...data, faxonly: checkbox ? checkbox.checked : false};
        },
    },
};